import React from 'react';
import '../Styles/Footer.css'
import { IoLocationOutline } from "react-icons/io5";
import { HiOutlineBellAlert } from "react-icons/hi2";
import { IoIosSearch } from "react-icons/io";
import { IoBagOutline } from "react-icons/io5";
import { SlUser } from "react-icons/sl";
import { Link, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

const Footer = ({ longitude, latitude }) => {
    const navigation = useNavigate();
    const totalItems = useSelector((state) => state.cart.totalItems);

    // console.log("latitude : ", latitude);
    // console.log("longitude : ", longitude);

    // When navigating to Profile
    const handleProfileNavigation = () => {
        navigation('/profile', { state: { longitude: longitude, latitude: latitude } });
    };


    return (
        <div style={{
            width: "100%", margin: "auto",
        }}>
            <div className="bottom-nav">
                <Link style={{textDecoration: "none"}} to="/">
                    <div className="nav-item active">
                        <span className="icon"><IoLocationOutline /></span>
                        <span className="label">Near Me</span>
                    </div>
                </Link>
                <Link style={{textDecoration: "none"}} to="/alerts">
                    <div className="nav-item">
                        <span className="icon"><HiOutlineBellAlert /></span>
                        <span className="label">Alerts</span>
                        {0 > 0 && <span className="notification-badge">0</span>}
                    </div>
                </Link>
                <Link style={{textDecoration: "none"}} to="/explore">
                    <div className="nav-item">
                        <span className="icon"><IoIosSearch /></span>
                        <span className="label">Explore</span>
                    </div>
                </Link>
                <Link style={{textDecoration: "none"}} to={{ pathname: '/cart', state: { longitude, latitude } }} >
                    <div className="nav-item">
                        <span className="icon"><IoBagOutline /></span>
                        <span className="label">Cart</span>
                        {1 > 0 && <span className="notification-badge">{totalItems}</span>}
                    </div>
                </Link>
                <div className="nav-item" onClick={handleProfileNavigation}>
                    <span className="icon"><SlUser /></span>
                    <span className="label">Account</span>
                </div>

            </div>
        </div>
    );
};

export default Footer;
